<div [id]="id" class="recommendation-text flex body-regular m-none break-word">
    <ng-content></ng-content>
</div>
